import { executeBridge, normalizeBridgeError } from './execute-bridge';
import { canIUse, paySharkRequest } from '@mtfe/msi-mtpay-api';
import {
  BridgeName,
  ParamTunnelBridgeAction,
  JSNotifyNativeBridgeAction,
  SharkFetchParams,
} from './constants';
import { NeoNamespace } from '../common-enum';
import { NeoError } from '../util/neo-error';
import { debug, DebugLevel } from '../util/debug';
import { env } from '@/common';
/**
 * 参数隧道桥 - 获取全量参数
 * @param params 桥调用参数
 * @param timeout 桥调用超时时间
 * @param {object} extParams
 * @returns {Promise} 桥调用 Promise
 */
export function paramTunnelAllParams<T>(
  params: any,
  timeout: number = 0,
  statParams: { retryTimes: number; retryDelay: number }
): Promise<T> {
  return executeBridge({
    bridgeName: BridgeName.ParamTunnel,
    bridgeData: {
      action: ParamTunnelBridgeAction.AllParams,
      ...params,
    },
    timeout,
    statParams,
  }).then((data: any) => {
    let parsedData = {};
    const result = data?.result;

    try {
      if (typeof result === 'string') {
        parsedData = JSON.parse(result);
      } else {
        parsedData = { ...result };
      }
    } catch (e) {
      return Promise.reject(
        new NeoError(
          NeoNamespace.Bridge,
          'json parse error',
          `${BridgeName.ParamTunnel}/${ParamTunnelBridgeAction.AllParams}`
        )
      );
    }

    return parsedData as T;
  });
}

/**
 * 获取主接口数据桥
 * @param {object} params 桥调用参数
 * @param {number} timeout 桥调用超时时间
 * @returns {Promise} 桥调用 Promise
 */
export function hybridFetch<T>(params: any, timeout = 0): Promise<T> {
  return executeBridge<T>({
    bridgeName: BridgeName.HybridFetch,
    bridgeData: {
      ...params,
    },
    timeout,
  }).then((result) => {
    normalizeBridgeError<T>(result, BridgeName.HybridFetch);
    return result.response.data;
  });
}

/**
 * JS 侧主动通知 Native
 * @param {string} action
 * @returns {Promise} 桥调用 Promise
 */
export function JSNotifyNative(action: string, data: any = {}) {
  if (env.isHarmony) return Promise.resolve();
  debug(
    NeoNamespace.BridgeExecute,
    DebugLevel.Info,
    `JSNotifyNative 入参：${action}`
  );
  return executeBridge<any>({
    bridgeName: BridgeName.JSNotifyNative,
    bridgeData: {
      action,
      data,
    },
  });
}

/**
 * 展示 Webview
 * @returns {Promise} 桥调用 Promise
 */
export function showWebview() {
  return JSNotifyNative(JSNotifyNativeBridgeAction.DataReadyRenderFinished);
}
export function downgrade(params: { message: string }) {
  return JSNotifyNative(JSNotifyNativeBridgeAction.NotifyDowngrade, params);
}
// /**
//  * 页面加载 JS 执行，全局函数挂载完成
//  * window.onNativeStatusChanged 函数定义完成
//  * @returns {Promise} 桥调用 Promise
//  */
// export function notifyJSReady() {
//   return JSNotifyNative(JSNotifyNativeBridgeAction.PageReadyToNative);
// }

/**
 * Shark 能力桥
 * @param params 参数
 */
export function sharkFetch<T>(params: SharkFetchParams): Promise<T> {
  if (env.isHarmony && KNB.env.isStandardKnb) {
    if (!canIUse('paySharkRequest')) {
        throw new NeoError(
          NeoNamespace.Bridge,
          'paySharkRequest has not been implemented.',
          BridgeName.SharkRequest
        )
    }
    return paySharkRequest(params).then((res) => {
      if (!res || !res.response) {
        throw new NeoError(
          NeoNamespace.Bridge,
          "property 'response' is empty",
          BridgeName.SharkRequest
        );
      }
      // msi包不支持泛型，需要手动转换
      return res.response as any as T;
    });
  }

  return executeBridge<T>({
    bridgeName: BridgeName.SharkRequest,
    bridgeData: { data: { ...params } },
    timeout: 2500,
  }).then((result: any) => {
    // TODO 格式一致后，去掉 any 类型
    // TODO 与 hybridFetch 桥数据返回不一致，单独校验
    // normalizeBridgeError<T>(result, BridgeName.SharkRequest);

    if (!result || !result.response) {
      throw new NeoError(
        NeoNamespace.Bridge,
        "property 'response' is empty",
        BridgeName.SharkRequest
      );
    }

    // TODO 格式一致后，result.response.data
    return result.response;
  });
}
